import { $isAtNodeEnd } from '@lexical/selection'
import { ElementNode, RangeSelection, TextNode } from 'lexical'

export const getSelectedNode = (
  selection: RangeSelection
): TextNode | ElementNode => {
  const { anchor, focus } = selection
  const anchorNode = selection.anchor.getNode()
  const focusNode = selection.focus.getNode()
  // eslint-disable-next-line no-object-comparison/object-equality
  if (anchorNode === focusNode) {
    return anchorNode
  }
  const isBackward = selection.isBackward()
  if (isBackward) {
    return $isAtNodeEnd(focus) ? anchorNode : focusNode
  }
  return $isAtNodeEnd(anchor) ? anchorNode : focusNode
}

export const notNullOrUndefinedOrEmpty = <TValue>(
  value: TValue | null | undefined
): value is TValue => !(value === null || value === undefined || value === '')
